// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/footer/app-card/app-card.component.scss
// module id = 297
// module chunks = 0